import Image, { type ImageProps } from "next/image";

import type { StrapiImage as StrapiImageType } from "@/shared/api/strapi";
import { getStrapiMediaUrl } from "@/shared/lib/strapi/getStrapiMediaUrl";

const devImageProps =
  process.env.NODE_ENV === "development" ? ({ unoptimized: true } as const) : {};

type StrapiImageProps = Omit<ImageProps, "src" | "alt"> & {
  image?: StrapiImageType | null;
  width: number;
  height: number;
  alt?: string;
};

export function StrapiImage({
  image,
  width,
  height,
  className,
  alt,
  ...rest
}: StrapiImageProps) {
  if (!image?.url) {
    return null;
  }

  return (
    <Image
      width={width}
      height={height}
      src={getStrapiMediaUrl(image.url)}
      alt={alt ?? image.alternativeText?.trim() ?? ""}
      className={className}
      {...devImageProps}
      {...rest}
    />
  );
}
